import styled from 'styled-components';

import { captionRegular } from 'styles/mixins/fonts';

export const EventPercent = styled.p`
  ${captionRegular};
  color: ${({ theme }) => theme.colors.grey.primary.standard};
`;
